import { atom } from "recoil";

export const pendingPackagingUpdatedFlagState = atom<boolean>({
  key: "pendingPackagingUpdatedFlagState",
  default: false,
});
